import React from 'react'

export function useEffectEvent<T extends Function>(fn: T): T {
  const ref = React.useRef<T | null>(null)
  useIsomorphicLayoutEffect(() => {
    ref.current = fn
  }, [fn])
  // @ts-ignore
  return React.useCallback<T>((...args) => {
    const f = ref.current!
    return f(...args)
  }, [])
}

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect
